// Rewrites blob.fun88.mx image URLs to Cloudflare Image Transformations
// (/cdn-cgi/image/) so game thumbnails are resized/re-encoded at the edge.
// Same-zone path rewrite, so it works regardless of which host the page
// itself is served from. Non-blob URLs pass through untouched.
//
// DO NOT rename this host as part of a site-wide domain change. The site moved
// to fun88mx.mx but the image CDN is still served from blob.fun88.mx
// (blob.fun88mx.mx does not resolve). Pointing this at any other host makes
// every thumbnail URL miss the match below and silently disables the
// transformation for the whole site.
const TRANSFORM_HOST = 'blob.fun88.mx'

// Single shared width so every surface (grid tiles, search results, top
// games) hits the same cached variant. onerror=redirect falls back to the
// original image if the transformation fails.
const cfImage = (url: string, width = 320, quality = 75) => {
  try {
    const parsed = new URL(url)
    if (parsed.hostname !== TRANSFORM_HOST) return url
    return `${parsed.origin}/cdn-cgi/image/width=${width},quality=${quality},format=auto,onerror=redirect${parsed.pathname}${parsed.search}`
  } catch {
    return url
  }
}

export default cfImage
